export enum ColorLevel {
	GREEN = 'Green',
	ORANGE = 'Orange',
	RED = 'Red'
}
